import { AccountManagmentModule } from '../account-managment/account-managment.module';
import { ApplicationPipesModule } from '../application-pipes.module';
import { AuthGuard } from '../../../_guards';
import { CdkTableModule } from '@angular/cdk/table';
import { CdkTreeModule } from '@angular/cdk/tree';
import { CommonModule, DecimalPipe } from '@angular/common';
import { DragDropModule } from '@angular/cdk/drag-drop';
// import { LoggedonUserComponent } from '../account-managment/loggedon-user/loggedon-user.component';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTreeModule } from '@angular/material/tree';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResizableModule } from 'angular-resizable-element';
import { RouterModule } from '@angular/router';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { UsersComponent } from './users.component';
import { MatChipsModule } from '@angular/material/chips';
import { NumberMaskModule } from '@directives/number-mask/number-mask.module';
import { PipesModule } from '@_pipes/pipes.module';

import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { RichTextEditorAllModule } from '@syncfusion/ej2-angular-richtexteditor';
import { ImageEditorModule } from '@syncfusion/ej2-angular-image-editor';
import { CurrencyFormatModule } from '@directives/currencyformat/currency-format.module';
import { MaterialModule } from 'src/app/Shared/material.module';

/**
 * This is using for set the route JSON
 */
const routes = [
  {
    path: '',
    component: UsersComponent,
    data: {
      title: 'Users',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'useractivity',
    component: UsersComponent,
    data: {
      title: 'User Activity',
    },
    canActivate: [AuthGuard],
  },
];

@NgModule({
  declarations: [UsersComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),

    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    FormsModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatTableModule,
    MatToolbarModule,
    MatSlideToggleModule,
    MatCardModule,
    MatSelectModule,
    MatPaginatorModule,
    MatAutocompleteModule,
    MatTabsModule,
    MatDialogModule,
    MatProgressSpinnerModule,

    MatCheckboxModule,
    DragDropModule,
    MatExpansionModule,
    MatRadioModule,
    // N level tree checkbox
    MatTreeModule,
    CdkTableModule,
    CdkTreeModule,
    ScrollingModule,
    MatNativeDateModule,
    ReactiveFormsModule,
    MatSortModule,
    ApplicationPipesModule,
    ResizableModule,
    PipesModule,
    MatChipsModule,
    NumberMaskModule,
    AccountManagmentModule,
    RichTextEditorAllModule,

    NgxMaskDirective,
    NgxMaskPipe,
    ImageEditorModule,
    CurrencyFormatModule,
    MaterialModule,
  ],
  providers: [DecimalPipe, provideNgxMask()],
  exports: [
    UsersComponent,
    MatTreeModule,
    CdkTableModule,
    CdkTreeModule,
    ScrollingModule,
    MatDatepickerModule,
  ],
  bootstrap: [],
})
export class UsersModule {}
